module.exports = __webpack_public_path__ + "img/uj_01.0f140719.jpg";